import * as _ from 'lodash';
// tslint:disable-next-line:no-submodule-imports
import { all, call, Effect, put, putResolve, select } from 'redux-saga/effects';
import { Server, Server2, ServerCollection, Workspace3 } from '../../clients/aasServerClient.generated';
import * as ServerRepository from '../../repositories/ServerRepository';
import { takeEveryWithErrorHandling } from '../sagas';
import { RootState } from '../store';
import { unselectAll} from '../tables/actionCreators';
import { storePagingState } from '../tables/actionCreators';
import { getFilters, getLimit, getPaging, getSearch, getSorting, getStart } from '../tables/selectors';
import { TableFilters, TablePaging, TableSorting } from '../tables/state';
import {
    fetchAllServers as fetchAllServersCreator,
    fetchTableServers as fetchServersCreator,
    savedSingleServer,
    storeAllServers,
    storeSingleServer,
    storeTableServers,
} from './actionCreators';
import {
    ActionTypeNames, CopySingleServerAction,
    CreateSingleServerAction,
    DeleteServersAction,
    FetchSingleServerAction,
    GenerateNewKeysAction,
    NewSingleServerAction,
    SaveSingleServerAction,
} from './actions';

function* fetchTableServers() {
    const start: number = yield select(getStart, 'servers');
    const limit: number = yield select(getLimit, 'servers');
    const sorting: TableSorting = yield select(getSorting, 'servers');
    const filters: TableFilters = yield select(getFilters, 'servers');
    const paging: TablePaging = yield select(getPaging, 'servers');
    const search: string = yield select(getSearch, 'servers');

    const res: ServerCollection = yield call(ServerRepository.getServers, limit, start, sorting, filters, search);
    yield all([
        putResolve(storeTableServers(res.items)),
        putResolve(storePagingState('servers', {
            numberOfItems: res.count || 0,
            numberOfPages: Math.ceil((res.count || 0) / paging.itemsPerPage)
        }))
    ]);
}

function* fetchTableServersNF() {
    const start: number = yield select(getStart, 'servers');
    const limit: number = yield select(getLimit, 'servers');
    const sorting: TableSorting = yield select(getSorting, 'servers');
    
    const paging: TablePaging = yield select(getPaging, 'servers');
    

    const res: ServerCollection = yield call(ServerRepository.getServersNF, limit, start, sorting);
    yield all([
        putResolve(storeTableServers(res.items)),
        putResolve(storePagingState('servers', {
            numberOfItems: res.count || 0,
            numberOfPages: Math.ceil((res.count || 0) / paging.itemsPerPage)
        }))
    ]);
}

export function* watchFetchTableServers() {
    yield takeEveryWithErrorHandling(ActionTypeNames.FetchTableServers, fetchTableServers);
}

export function* watchFetchTableServersNF() {
    yield takeEveryWithErrorHandling(ActionTypeNames.FetchTableServersNF, fetchTableServersNF);
}

function* fetchAllServers() {
    const res: ServerCollection = yield call(ServerRepository.getAllServers);
    yield putResolve(storeAllServers(res.items));
}

export function* watchFetchAllServers() {
    yield takeEveryWithErrorHandling(ActionTypeNames.FetchAllServers, fetchAllServers);
}

function* fetchSingleServer(action: FetchSingleServerAction) {
    const server: Server = yield call(ServerRepository.getServer, action.hostname);
    yield putResolve(storeSingleServer(server));
}

function* watchFetchSingleServer() {
    yield takeEveryWithErrorHandling(ActionTypeNames.FetchSingleServer, fetchSingleServer);
}

function* copySingleServer(action: CopySingleServerAction) {
    const res: Server = yield call(ServerRepository.getServer, action.hostname);
    const server: Partial<Server> = {
        atp_url: res.atp_url,
        hostname: '',
        secure: res.secure,
    };
    yield putResolve(storeSingleServer(server));
}

function* watchCopySingleServer() {
    yield takeEveryWithErrorHandling(ActionTypeNames.CopySingleServer, copySingleServer);
}

function* newSingleServer(action: NewSingleServerAction) {
    const server: Partial<Server> = {
        atp_url: '',
        hostname: '',
        secure: true,
    };
    yield putResolve(storeSingleServer(server));
}

function* watchNewSingleServer() {
    yield takeEveryWithErrorHandling(ActionTypeNames.NewSingleServer, newSingleServer);
}

function* saveSingleServer(action: SaveSingleServerAction) {
    const res = yield call(
        ServerRepository.updateServer,
        action.server
    );
    yield putResolve(savedSingleServer());
    yield all([
        put(fetchServersCreator()),
        put(fetchAllServersCreator()),
    ]);
}

function* watchSaveSingleServer() {
    yield takeEveryWithErrorHandling(ActionTypeNames.SaveSingleServer, saveSingleServer);
}

function* createSingleServer(action: CreateSingleServerAction) {
    const res = yield call(
        ServerRepository.createServer,
        action.server
    );
    yield putResolve(savedSingleServer());
    yield all([
        put(fetchServersCreator()),
        put(fetchAllServersCreator()),
    ]);
}

function* watchCreateSingleServer() {
    yield takeEveryWithErrorHandling(ActionTypeNames.CreateSingleServer, createSingleServer);
}

function* watchDeleteServers() {
    yield takeEveryWithErrorHandling(ActionTypeNames.DeleteServers, deleteServers);
}

function* deleteServers(action: DeleteServersAction) {
    yield call(ServerRepository.deleteServers, action.serverHostnames);
    yield put(unselectAll('applications',action.serverHostnames)) ;   

    yield putResolve(fetchServersCreator());
}

function* watchGenerateNewKeys() {
    yield takeEveryWithErrorHandling(ActionTypeNames.GenerateNewKeys, generateNewKeys);
}

function* generateNewKeys(action: GenerateNewKeysAction) {
    yield call(ServerRepository.generateNewKeys, action.serverHostnames);
    yield putResolve(fetchServersCreator());
}

export default [watchFetchTableServers,watchFetchTableServersNF, watchFetchAllServers,
    watchDeleteServers, watchCopySingleServer, watchGenerateNewKeys,
    watchFetchSingleServer, watchSaveSingleServer, watchCreateSingleServer, watchNewSingleServer];